/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { QuoteTestExecutionCommentType } from "./QuoteTestExecutionCommentType";
import {
  QuoteTestExecutionCommentTypeFromJSON,
  QuoteTestExecutionCommentTypeFromJSONTyped,
  QuoteTestExecutionCommentTypeToJSON,
  QuoteTestExecutionCommentTypeToJSONTyped,
} from "./QuoteTestExecutionCommentType";

/**
 *
 * @export
 * @interface QuoteTestExecutionComment
 */
export interface QuoteTestExecutionComment {
  /**
   *
   * @type {string}
   * @memberof QuoteTestExecutionComment
   */
  executionCommentId?: string;
  /**
   *
   * @type {string}
   * @memberof QuoteTestExecutionComment
   */
  executionId?: string;
  /**
   *
   * @type {string}
   * @memberof QuoteTestExecutionComment
   */
  expectationId?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof QuoteTestExecutionComment
   */
  createdAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof QuoteTestExecutionComment
   */
  createdBy?: string;
  /**
   *
   * @type {QuoteTestExecutionCommentType}
   * @memberof QuoteTestExecutionComment
   */
  type?: QuoteTestExecutionCommentType;
  /**
   *
   * @type {boolean}
   * @memberof QuoteTestExecutionComment
   */
  isResolved?: boolean;
  /**
   *
   * @type {string}
   * @memberof QuoteTestExecutionComment
   */
  text?: string;
  /**
   *
   * @type {boolean}
   * @memberof QuoteTestExecutionComment
   */
  isPinned?: boolean;
  /**
   *
   * @type {string}
   * @memberof QuoteTestExecutionComment
   */
  replyTo?: string;
}

/**
 * Check if a given object implements the QuoteTestExecutionComment interface.
 */
export function instanceOfQuoteTestExecutionComment(
  value: object,
): value is QuoteTestExecutionComment {
  return true;
}

export function QuoteTestExecutionCommentFromJSON(
  json: any,
): QuoteTestExecutionComment {
  return QuoteTestExecutionCommentFromJSONTyped(json, false);
}

export function QuoteTestExecutionCommentFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): QuoteTestExecutionComment {
  if (json == null) {
    return json;
  }
  return {
    executionCommentId:
      json["executionCommentId"] == null
        ? undefined
        : json["executionCommentId"],
    executionId: json["executionId"] == null ? undefined : json["executionId"],
    expectationId:
      json["expectationId"] == null ? undefined : json["expectationId"],
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
    createdBy: json["createdBy"] == null ? undefined : json["createdBy"],
    type:
      json["type"] == null
        ? undefined
        : QuoteTestExecutionCommentTypeFromJSON(json["type"]),
    isResolved: json["isResolved"] == null ? undefined : json["isResolved"],
    text: json["text"] == null ? undefined : json["text"],
    isPinned: json["isPinned"] == null ? undefined : json["isPinned"],
    replyTo: json["replyTo"] == null ? undefined : json["replyTo"],
  };
}

export function QuoteTestExecutionCommentToJSON(
  json: any,
): QuoteTestExecutionComment {
  return QuoteTestExecutionCommentToJSONTyped(json, false);
}

export function QuoteTestExecutionCommentToJSONTyped(
  value?: QuoteTestExecutionComment | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    executionCommentId: value["executionCommentId"],
    executionId: value["executionId"],
    expectationId: value["expectationId"],
    createdAt: value["createdAt"],
    createdBy: value["createdBy"],
    type: QuoteTestExecutionCommentTypeToJSON(value["type"]),
    isResolved: value["isResolved"],
    text: value["text"],
    isPinned: value["isPinned"],
    replyTo: value["replyTo"],
  };
}
